import { LayoutDefault } from '@/layouts'

export const routeIreg = [
  {
    path: '*',
    redirect: { name: 'home' },
  },
  {
    path: '/closeWindow',
    name: 'closeWindow',
    component: () =>
      import(
        /* webpackChunkName: "closeWindow" */ '@/views/closeWindow/closeWindow.vue'
      ),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
    meta: {
      title: 'Login',
      open: true,
    },
    hidden: true,
  },
  {
    path: '/ipasas',
    name: 'ipasasAuth',
    meta: {
      title: 'iPASAS',
      open: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "ipasasAuth" */ '@/views/auth/IpasasAuth.vue'
      ),
  },
  {
    path: '/',
    name: 'home',
    component: LayoutDefault,
    redirect: { name: 'dashboard' },
    meta: {
      title: 'Pagrindinis',
      open: true,
    },
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () =>
          import(
            /* webpackChunkName: "journalTab" */ '@/views/dashboard/Dashboard.vue'
          ),
        meta: {
          title: '',
        },
      },
      {
        path: '/journal',
        name: 'journalTab',
        component: () =>
          import(
            /* webpackChunkName: "journalTab" */ '@/views/journal/JournalTab.vue'
          ),
        meta: {
          title: 'Dokumentai',
        },
        children: [
          {
            path: 'checking',
            name: 'checkingJournal',
            meta: {
              title: 'Nepatikrintų dokumentų žurnalas',
            },
            children: [
              {
                path: 'review/:id',
                name: 'journalCheckingForm',
                meta: {
                  title: 'Dokumento peržiūra / tvarkymas',
                },
              }
            ]
          },
          {
            path: 'received',
            name: 'journalReceived',
            meta: {
              title: 'Gautų dokumentų žurnalas',
            },
            children: [
              {
                path: 'data/review/:id',
                name: 'adminJournalReceivedForm',
                meta: {
                  title: 'Dokumento peržiūra / tvarkymas',
                },
              }
            ]
          },
          {
            path: 'notification',
            name: 'journalNotification',
            meta: {
              title: 'Siunčiamų dokumentų žurnalas',
            },
            children: [
              {
                path: 'view/:id',
                name: 'adminJournalNotificationView',
                meta: {
                  title: 'Dokumento peržiūra',
                },
              }
            ]
          },
          {
            path: 'registry/messages',
            name: 'registryMessages',
            meta: {
              title: 'Registro pranešimai',
            },
          },
        ],
      },
      {
        path: '/search',
        name: 'searchTab',
        component: () =>
          import(/* webpackChunkName: "searchTab" */ '@/views/search/SearchTab.vue'),
        meta: {
          title: 'Paieškos',
        },
        children: [
          {
            path: 'new',
            name: 'searchNew',
            meta: {
              title: 'Paieška',
            },
          },
          {
            path: 'list',
            name: 'searchList',
            meta: {
              title: 'Paieškų sąrašas',
            },
            children: [
              {
                path: 'order/:id/:list?',
                name: 'adminOrderFormList',
                meta: {
                  title: 'Išrašas',
                },
              },
            ]
          },
          {
            path: 'orders',
            name: 'searchOrders',
            meta: {
              title: 'Išrašų užsakymas',
            },
            children: [
              {
                path: 'order/:id/:list?',
                name: 'adminOrderForm',
                meta: {
                  title: 'Išrašas',
                },
              },
            ]
          },

        ],
      },
      {
        path: '/reports',
        name: 'reportsTab',
        component: () =>
          import(/* webpackChunkName: "searchTab" */ '@/views/reports/ReportsTab.vue'),
        meta: {
          title: 'Ataskaitos',
        },
        children: [
          {
            path: 'new',
            name: 'reports',
            meta: {
              title: 'Ataskaitos formavimas',
            },
          },
        ],
      },
      {
        path: 'services-import',
        name: 'adminServiceImportForm',
        component: () =>
        import(
          /* webpackChunkName: "AdminServiceImportForm" */ '@/views/classifiers/services/AdminServiceImportForm.vue'
        ),
        meta: {
          title: 'Paslaugų įkėlimas',
        },
      },
      {
        path: '/classifier',
        name: 'classifierTab',
        component: () =>
          import(
            /* webpackChunkName: "ClassifierTab" */ '@/views/classifiers/ClassifierTab.vue'
          ),
        meta: {
          title: 'Klasifikatoriai',
        },
        children: [
          {
            path: 'services',
            name: 'classifierServices',
            meta: {
              title: 'Paslaugos ir veiksmai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminServiceForm',
                meta: {
                  title: 'Paslauga / veiksmas',
                },
              },
              {
                path: 'form/parent/:parent_id?',
                name: 'adminParentServiceForm',
                meta: {
                  title: 'Paslauga / veiksmas',
                },
              },
            ]
          },
          {
            path: 'mandate-types',
            name: 'classifierMandateTypes',
            meta: {
              title: 'Įgaliojimo tipai',
            },
            children: [
              {
                path: 'form/:id?/:duplicate?',
                name: 'adminMandateTypeForm',
                meta: {
                  title: 'Įgaliojimo tipas',
                },
              },
            ]

          },
          {
            path: 'institutions',
            name: 'classifierInstitutions',
            meta: {
              title: 'Institucijos',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminInstitutionForm',
                meta: {
                  title: 'Institucija',
                },
              },
            ]
          },
          {
            path: 'institutions-groups',
            name: 'classifierInstitutionsGroups',
            meta: {
              title: 'Institucijų grupės',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminInstitutionGroupForm',
                meta: {
                  title: 'Institucijų grupė',
                },
              },
            ]
          },
          {
            path: 'mandate-termination',
            name: 'classifierMandateTermination',
            meta: {
              title: 'Įgaliojimo pasibaigimo ir pakeitimo pagrindai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminMandateTerminationForm',
                meta: {
                  title: 'Įgaliojimo pasibaigimo pagrindas',
                },
              },
            ]
          },
          {
            path: 'mandate-suspension',
            name: 'classifierMandateSuspension',
            meta: {
              title: 'Įgaliojimo sustabdymo ir sustabdymo panaikinimo pagrindai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminMandateSuspensionForm',
                meta: {
                  title: 'Įgaliojimo sustabdymo pagrindas',
                },
              },
            ]
          },
          {
            path: 'reject-reasons',
            name: 'classifierRejectReasons',
            meta: {
              title: 'Atsisakymo pagrindai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminRejectReasonForm',
                meta: {
                  title: 'Atsisakymo pagrindas',
                },
              },
            ]
          },
          {
            path: 'email-sms',
            name: 'classifierEmailAndSMS',
            meta: {
              title: 'El. pašto ir SMS tekstai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminEmailAndSmsForm',
                meta: {
                  title: 'Šablonas',
                },
              },
            ]
          },
          {
            path: 'countries',
            name: 'classifierCountries',
            meta: {
              title: 'Šalys',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminCountryForm',
                meta: {
                  title: 'Šalis',
                },
              },
            ]
          },
          {
            path: 'cancel-reasons',
            name: 'classifierCancelReasons',
            meta: {
              title: 'Panaikinimo / atsisakymo požymiai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminCancelReasonForm',
                meta: {
                  title: 'Panaikinimo / atsisakymo požymis',
                },
              },
            ]
          },
          {
            path: 'error-notifications',
            name: 'classifierErrorNotifications',
            meta: {
              title: 'Informaciniai ir klaidų pranešimai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminErrorNotificationForm',
                meta: {
                  title: 'Informacinis ir klaidos pranešimas',
                },
              },
            ]
          },
          {
            path: 'security-notifications',
            name: 'classifierSecurityNotifications',
            meta: {
              title: 'Saugos pranešimai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminSecurityNotificationForm',
                meta: {
                  title: 'Saugos pranešimas',
                },
              },
            ]
          },
          {
            path: 'ipasas-ja-permissions',
            name: 'ipasasJaPermissions',
            meta: {
              title: 'iPasas teisės (JA)',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'ipasasJaPermissionForm',
                meta: {
                  title: 'JA teisė',
                },
              },
            ]
          },
          {
            path: 'ipasas-fa-permissions',
            name: 'ipasasFaPermissions',
            meta: {
              title: 'iPasas teisės (FA)',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'ipasasFaPermissionForm',
                meta: {
                  title: 'FA teisė',
                },
              },
            ]
          },
          {
            path: 'customCalendar',
            name: 'customCalendar',
            meta: {
              title: 'Šventinių dienų sąrašas',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'customCalendarForm',
                meta: {
                  title: 'Diena',
                },
              },
            ]
          },
          {
            path: 'nirvarLimit',
            name: 'nirvarLimit',
            meta: {
              title: 'NIRVAR sritys',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'nirvarLimitForm',
                meta: {
                  title: 'NIRVAR sritis',
                },
              },
            ]
          },
          {
            path: 'person-document-kinds',
            name: 'personDocumentKind',
            meta: {
              title: 'Asmens dokumento rūšys',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'personDocumentKindForm',
                meta: {
                  title: 'Asmens dokumento rūšis',
                },
              },
            ]
          },
          {
            path: 'rc-ses-limitation',
            name: 'rcSesLimitation',
            meta: {
              title: 'RC SES apribojimai',
            },
            redirect: {name: 'serviceLimitation'},
            children: [
              {
                path: 'service-limitation',
                name: 'serviceLimitation',
                meta: {
                  title: 'RC SES paslaugų apribojimai',
                },
                children: [
                  {
                    path: ':id?',
                    name: 'serviceLimitationForm',
                    meta: {
                      title: 'RC SES Paslaugos apribojimai',
                    },
                  },
                ]
              },
              {
                path: 'list-limitation',
                name: 'listLimitation',
                meta: {
                  title: 'RC SES sąrašų apribojimai',
                },
                children: [
                  {
                    path: ':id?',
                    name: 'listLimitationForm',
                    meta: {
                      title: 'RC SES sąrašo apribojimai',
                    },
                  },
                ]
              },
            ],
          },
          // {
          //   path: 'service-limitation',
          //   name: 'serviceLimitation',
          //   meta: {
          //     title: 'RC SES apribojimai',
          //   },
          //   children: [
          //     {
          //       path: 'service-limitation/:id?',
          //       name: 'serviceLimitationForm',
          //       meta: {
          //         title: 'Paslaugos apribojimai',
          //       },
          //     },
          //   ]
          // },
          // {
          //   path: 'tooltips',
          //   name: 'classifierTooltips',
          //   meta: {
          //     title: 'Patartys (angl. tooltips)',
          //   },
          //   children: [
          //     {
          //       path: 'form/:id?',
          //       name: 'adminTooltipForm',
          //       meta: {
          //         title: 'Patartis (angl. tooltip)',
          //       },
          //     },
          //   ]
          // },
          {
            path: 'authorizing-persons',
            name: 'classifierAuthorizingPersons',
            meta: {
              title: 'Įgaliojimą tvirtinantys asmenys',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminAuthorizingPersonForm',
                meta: {
                  title: 'Įgaliojimą tvirtinantis asmuo',
                },
              },
            ]
          },
        ],
      },
      {
        path: '/admin',
        name: 'adminTab',
        component: () =>
          import(/* webpackChunkName: "adminTab" */ '@/views/administration/AdminTab.vue'),
        meta: {
          title: 'Administravimas',
        },
        children: [
          {
            path: 'system-blacklist',
            name: 'adminSystemBlacklist',
            meta: {
              title: 'Draudžiami paslaugų teikėjai',
            },
          },
          {
            path: 'system-notifications',
            name: 'adminSystemNotifications',
            meta: {
              title: 'Sistemos pranešimai',
            },
            children: [
              {
                path: 'form/:id?',
                name: 'adminSystemNotificationForm',
                meta: {
                  title: 'Sistemos pranešimas',
                },
              },
            ]
          },
          {
            path: 'parameters',
            name: 'adminParameters',
            meta: {
              title: 'Sistemos parametrai',
            },
          },
          {
            path: 'records',
            name: 'adminRecords',
            meta: {
              title: 'Sisteminiai įrašai',
            },
          },
          {
            path: 'data',
            name: 'adminData',
            meta: {
              title: 'Duomenų valdymas',
            },
          },
          {
            path: 'jar-data',
            name: 'JarContainer',
            meta: {
              title: 'JAR duomenų valdymas',
            },
            redirect: { name: 'adminJarFailedJobs' },
            children:[
              {
                path: 'jar-failed-jobs',
                name: 'adminJarFailedJobs',
                meta: {
                  title: 'Nepavykę JAR duomenų perdavimai',
                },
              },
              {
                path: 'legal-entities',
                name: 'adminLegalentitiesWithoutObj',
                meta: {
                  title: 'Juridiniai asmenys be OBJ_ID',
                },
              },
            ]
          },
          {
            path: 'performed-searches',
            name: 'performedSearches',
            meta: {
              title: 'Įgaliojimų / prokūrų atliktos paieškos',
            },
          },
          {
            path: 'logs',
            name: 'adminLogs',
            meta: {
              title: 'Užklausų žurnalas',
            },
            redirect: { name: 'adminLogNirvar' },
            children:[
              {
                path: 'nirvar',
                name: 'adminLogNirvar',
                meta: {
                  title: 'NIRVAR LOG',
                },
              },
              {
                path: 'saperion',
                name: 'adminLogSaperion',
                meta: {
                  title: 'SAPERION LOG',
                },
              },
              {
                path: 'jarProcuracy',
                name: 'adminLogJarProcuracy',
                meta: {
                  title: 'JAR LOG',
                },
              },
              {
                path: 'asmenys',
                name: 'adminLogAsmenys',
                meta: {
                  title: 'ASMENYS LOG',
                },
              },
              {
                path: 'pas',
                name: 'adminLogPas',
                meta: {
                  title: 'PAS LOG',
                },
              },
              {
                path: 'broker',
                name: 'adminLogBroker',
                meta: {
                  title: 'BROKER LOG',
                },
              },
              {
                path: 'apiRequest',
                name: 'adminLogApiRequest',
                meta: {
                  title: 'WS API LOG',
                },
              },
            ]
          },
          {
            path: 'view-data',
            name: 'viewData',
            meta: {
              title: 'View duomenys',
            },
            redirect: { name: 'viewDataFft' },
            children:[
              {
                path: 'FFT',
                name: 'viewDataFft',
                meta: {
                  title: 'V_FFT_VAIDMUO_TEISES',
                },
              },
              {
                path: 'FATE',
                name: 'viewDataFate',
                meta: {
                  title: 'V_FATE_VAIDMUO_TEISES',
                },
              },
            ]
          },
          {
            path: 'public-ja-forms',
            name: 'publicJaForms',
            meta: {
              ttile: 'Viešų JA sąrašas',
            }
          },
          {
            path: 'person-rules',
            name: 'personRules',
            meta: {
              title: 'Asmenų pridėjimo taisyklės'
            },
            redirect: { name: 'objectPersonRules' },
            children: [
              {
                path: 'object-person-rules',
                name: 'objectPersonRules',
                meta: {
                  title: 'Objektų asmenys'
                },
                children: [
                  {
                    path: ':id',
                    name: 'objectPersonRuleForm',
                    meta: {
                      title: 'Objekto asmens pridėjimo taisyklės',
                    },
                  },
                ]
              },
              {
                path: 'signing-person-rules',
                name: 'signingPersonRules',
                meta: {
                  title: 'Pasirašantys asmenys'
                },
                children: [
                  {
                    path: ':id',
                    name: 'signingPersonRuleForm',
                    meta: {
                      title: 'Pasirašantys asmenys',
                    },
                  },
                ]
              },
              {
                path: 'representative-person-rules',
                name: 'representativePersonRules',
                meta: {
                  title: 'JA atstovų tikrinimo taisyklės'
                },
                children: [
                  {
                    path: ':id',
                    name: 'representativePersonRuleForm',
                    meta: {
                      title: 'JA atstovų tikrinimo taisyklės',
                    },
                  },
                ]
              }
            ]
          },
          {
            path: 'jar-fact-ipas-roles',
            name: 'jarFactIpasRoles',
            meta: {
              ttile: 'JAR faktas ir iPasas vaidmuo',
            }
          },
        ],
      },
      {
        path: '/errors-correction',
        name: 'errorsCorrectionTab',
        component: () =>
          import(/* webpackChunkName: "adminTab" */ '@/views/errorsCorrection/errorsCorrectionTab.vue'),
        meta: {
          title: 'Kalidų taisymas',
        },
        children: [
          {
            path: 'list',
            name: 'errorsCorrectionList',
            meta: {
              title: 'Rengiami ir pateikti klaidų taisymai',
            },
          },
          {
            path: 'form/:id?',
            name: 'errorsCorrectionNew',
            meta: {
              title: 'Pranešimas',
            },
          },
          {
            path: 'list/form/:id',
            name: 'errorsCorrectionListNew',
            meta: {
              title: 'Pranešimas',
            },
          },
        ],
      },
      {
        path: '/messages',
        name: 'messagesTab',
        component: () =>
          import(/* webpackChunkName: "adminTab" */ '@/views/messages/messagesTab.vue'),
        meta: {
          title: 'Rengiami / pateikti pranešimai',
        },
        children: [
          {
            path: 'messages/prepared-sent',
            name: 'adminMessagesPreparedSent',
            meta: {
              title: 'Rengiami ir pateikti pranešimai',
            },
          },
          {
            path: 'messages/form/:id?',
            name: 'adminMessageNew',
            meta: {
              title: 'Pranešimas',
            },
          },
          {
            path: 'messages/list/form/:id',
            name: 'adminMessageListNew',
            meta: {
              title: 'Pranešimas',
            },
          },
          {
            path: 'requests/prepared-sent',
            name: 'adminRequestsPreparedSent',
            meta: {
              title: 'Pradiniai prašymai',
            },
          },
          {
            path: 'requests/form/:id?',
            name: 'adminRequestNew',
            meta: {
              title: 'Prašymas',
            },
          },
          {
            path: 'requests/list/form/:id',
            name: 'adminRequestListNew',
            meta: {
              title: 'Prašymas',
            },
          },
        ],
      },
      {
        path: '/object-data-change',
        name: 'objectDataChangeTab',
        component: () =>
          import(/* webpackChunkName: "adminTab" */ '@/views/objectDataChange/objectDataChangeTab.vue'),
        meta: {
          title: 'Objektų duomenų kitimo sąrašas',
        },
        children: [
          {
            path: 'list',
            name: 'adminObjectDataChange',
            meta: {
              title: 'Objektų duomenų kitimo sąrašas',
            },
            children: [
              {
                path: 'info/:id',
                name: 'adminObjectDataChangeForm',
                meta: {
                  title: 'Objekto informacija',
                },
              },
            ],
          },
        ],
      },
      {
        path: '/archive',
        name: 'archiveTab',
        component: () =>
          import(/* webpackChunkName: "adminTab" */ '@/views/archive/archiveTab.vue'),
        meta: {
          title: 'Archyvas',
        },
        children: [
          {
            path: 'object-archive',
            name: 'adminObjectArchive',
            meta: {
              title: 'Objektų archyvas',
            },
          },
          {
            path: 'destroyed-objects',
            name: 'adminDestroyedObjectsList',
            meta: {
              title: 'Naikintinų duomenų sąrašas',
            },
          },
          {
            path: 'destruction-acts',
            name: 'adminDataDestructionActs',
            meta: {
              title: 'Duomenų naikinimo aktai',
            },
          },
          {
            path: 'statement-archive',
            name: 'adminStatementArchive',
            meta: {
              title: 'Atliktų paieškų sąrašas',
            },
          },
          {
            path: 'destruction-reports',
            name: 'adminDataDestructionReports',
            meta: {
              title: 'Paieškų naikinimo ataskaitos',
            },
          },
        ],
      },
      {
        path: '/404',
        name: 'sav404',
        component: () =>
          import(
            /* webpackChunkName: "savNotifications" */ '@/views/administration/pages/404'
          ),
        meta: {
          title: '404',
        },
      },
      {
        path: '/examples',
        name: 'examplesTab',
        component: () =>
          import(/* webpackChunkName: "adminTab" */ '@/views/examples/examplesTab.vue'),
        meta: {
          title: 'examples',
        },
        children: [
          {
            path: 'testElementsForm',
            name: 'testElementsForm',
            meta: {
              title: 'testElementsForm',
            },
          },
          {
            path: 'testUploadForm',
            name: 'testUploadForm',
            meta: {
              title: 'testUploadForm',
            },
          },
          {
            path: 'testCKEditorForm',
            name: 'testCKEditorForm',
            meta: {
              title: 'testCKEditorForm',
            },
          },
        ],
      },
    ],
  },
]
